import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { bootstrapSession } from "@/lib/lytick/bootstrap-session";
import "./globals.css";

// Sync: restore session state from localStorage so chartStore has symbol/tf
bootstrapSession();

// Warm the klinecharts chunk in parallel with React's first render
import("klinecharts").catch(() => {});

const queryClient = new QueryClient();

const topLevelFallback = (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100dvh",
      gap: "12px",
      backgroundColor: "var(--bg-base)",
      color: "var(--text-primary)",
    }}
  >
    <p style={{ fontSize: "14px" }}>Something went wrong.</p>
    <button
      onClick={() => location.reload()}
      style={{
        fontSize: "13px",
        padding: "6px 16px",
        borderRadius: "6px",
        border: "1px solid var(--border-default)",
        background: "var(--bg-elevated)",
        color: "var(--text-primary)",
        cursor: "pointer",
      }}
    >
      Reload
    </button>
  </div>
);

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <ErrorBoundary fallback={topLevelFallback}>
      <App />
    </ErrorBoundary>
  </QueryClientProvider>
);
